import { render, staticRenderFns } from "./ViolationForm.vue?vue&type=template&id=2af09086&scoped=true"
import script from "./ViolationForm.vue?vue&type=script&lang=js"
export * from "./ViolationForm.vue?vue&type=script&lang=js"
import style0 from "./ViolationForm.scss?vue&type=style&index=0&id=2af09086&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af09086",
  null
  
)

export default component.exports